<i18n src="@/i18n/template/projects/operation/components/LoginMFA.json"></i18n>
<template>
  <el-dialog
    title=""
    append-to-body
    width="400px"
    :visible.sync="visible"
    class="login-mfa"
  >
    <p class="title">{{ $t('LoginMFAAlert') }}</p>
    <p class="subtitle">{{ $t('SendTo') }}: {{ phone }}</p>
    <div class="input-row">
      <el-input v-model="otp" :maxLength="6" :placeholder="$t('SMSCode')" />
      <el-button
        :disabled="smsCounting"
        :loading="smsLoading"
        @click="sendSMS"
        >{{ smsText }}</el-button
      >
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onCancel">{{ $t('cancel') }}</el-button>
      <el-button
        type="primary"
        :disabled="otp.length !== 6"
        @click="confirmClick"
        >{{ $t('confirm') }}</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
let mfaInstance = null
/**
 * 打开MFA认证弹窗
 * @type {(options: {
  phone: string,
  sessionId: string,
  bizId: string,
  method: string,
  onSuccess: (res: VerifyResponse) => void,
  onCancel?: () => void,
  onClose?: () => void
}) => void} 
 */
export function openMFAModal(options) {
  if (!mfaInstance) {
    console.error('LoginMFA not created')
    return
  }
  mfaInstance.openWithOptions(options)
}

const SessionTimeOutCode = 'MFAAE0000'

export default {
  data() {
    return {
      phone: '',
      visible: false,
      smsAlreadySent: false,
      smsLoading: false,
      smsCounting: false,
      otp: '',
      smsText: 'SMS'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.otp = ''
        this.smsText = 'SMS'
        this.smsLoading = false
        this.smsCounting = false
        this.smsAlreadySent = false
      } else {
        this.propOptions = null
        this.stopSMSCountDown()
      }
    }
  },
  created() {
    mfaInstance = this
  },
  beforeDestroy() {
    mfaInstance = null
  },
  methods: {
    openWithOptions(options) {
      let loading = this.$loading()
      loading.close()
      this.propOptions = options
      this.phone = options.phone
      this.visible = true
    },
    async sendSMS() {
      if (this.smsLoading || this.smsCounting) return
      this.smsLoading = true
      this.smsCounting = true
      let res = await this.$api
        .post({
          url: 'common/authentication/send',
          data: {
            sessionId: this.propOptions.sessionId,
            bizId: this.propOptions.bizId,
            method: this.propOptions.method
          },
          rawData: true,
          showError: false
        })
        .catch(() => {
          return {}
        })
      this.smsLoading = false
      if (res.code === SessionTimeOutCode) {
        this.smsCounting = false
        this.$confirm('Sesssion Expired, Please login again', '', {
          type: 'error',
          closeOnClickModal: false,
          showCancelButton: false,
          showClose: false,
          callback: () => this.onCancel()
        })
        return
      }
      if (res.code === '0000') {
        this.smsAlreadySent = true
        this.smsText = '60s'
        this.startSMSCountDown()
      } else {
        this.smsCounting = false
        this.$message.error(res.msg || 'Request Failed')
      }
    },
    startSMSCountDown() {
      this.stopSMSCountDown()
      this.smsCounting = true
      this.smsLoading = false
      let time = 60
      this.smsTimer = setInterval(() => {
        time--
        if (time <= 0) {
          this.stopSMSCountDown()
          this.smsText = 'SMS'
        } else {
          this.smsText = `${time}s`
        }
      }, 1000)
    },
    stopSMSCountDown() {
      this.smsTimer && clearInterval(this.smsTimer)
      this.smsTimer = null
      this.smsCounting = false
      this.smsLoading = false
    },
    async confirmClick() {
      if (!this.smsAlreadySent) {
        this.$confirm(
          `You haven't sent the SMS code yet. Do you want to send it now?`,
          '',
          {
            closeOnClickModal: false
          }
        )
          .then(() => {
            this.sendSMS()
          })
          .catch(() => {
            // cancale
          })
        return
      }
      const value = this.otp.substring(0, 6)
      if (value.length !== 6) return
      if (this.apiLoading) return
      this.apiLoading = true
      let loading = this.$loading()
      let res = await this.$api.post({
        url: 'common/authentication/verify',
        data: {
          sessionId: this.propOptions.sessionId,
          bizId: this.propOptions.bizId,
          method: 'SMS',
          credential: {
            smsCode: value
          },
          step: 2
        },
        rawData: true,
        showError: false
      })
      this.apiLoading = false
      loading.close()

      if (res.code === SessionTimeOutCode) {
        this.$confirm('Sesssion Expired, Please login again', '', {
          type: 'error',
          closeOnClickModal: false,
          showCancelButton: false,
          showClose: false,
          callback: () => this.onCancel()
        })
        return
      }
      if (res?.data?.completed) {
        this.propOptions.onSuccess?.(res.data)
        this.propOptions.onClose?.()
      } else {
        this.$message.error(res?.msg || 'Request Failed')
        this.otp = ''
      }
    },
    onCancel() {
      this.visible = false
      this.propOptions.onCancel?.()
      this.propOptions.onClose?.()
    }
  }
}
</script>
<style lang="scss">
.login-mfa {
  .title {
    font-size: 16px;
    color: $--color-danger;
  }
  .subtitle {
    font-size: 14px;
    color: '#666';
    margin-top: 24px;
    margin-bottom: 10px;
  }
  .input-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    .el-input {
      flex: 1;
    }
  }
}
</style>
